/**
 * abilityVfxMageMeshes — Shape dispatch for SPY-212 mage wave (OCP).
 */
import {
  buildLightBinding,
  buildPrismaticBarrier,
  buildLucentSingularity,
  buildFinalSpark
} from './abilityVfxLux.js';
import {
  buildSear,
  buildPillarOfFlame,
  buildConflagration,
  buildPyroclasm
} from './abilityVfxBrand.js';
import {
  buildBalefulStrike,
  buildDarkMatter,
  buildEventHorizon,
  buildPrimordialBurst
} from './abilityVfxVeigar.js';

const MAGE_SHAPE_BUILDERS = {
  light_binding: buildLightBinding,
  prismatic_barrier: buildPrismaticBarrier,
  lucent_singularity: buildLucentSingularity,
  final_spark: buildFinalSpark,
  sear: buildSear,
  pillar_of_flame: buildPillarOfFlame,
  conflagration: buildConflagration,
  pyroclasm: buildPyroclasm,
  baleful_strike: buildBalefulStrike,
  dark_matter: buildDarkMatter,
  event_horizon: buildEventHorizon,
  primordial_burst: buildPrimordialBurst
};

/** @returns {object|null} */
export function buildMageAbilityMesh(THREE, spec) {
  const build = MAGE_SHAPE_BUILDERS[spec?.shape];
  return build ? build(THREE, spec) : null;
}
